import React, { useState, useEffect } from "react";
import ToggleSwitch from "../../components/ToggleSwitch/ToggleSwitch";
import { 
  useUpdateSalaryComponentActiveStatus, 
  useDeleteSalaryComponents 
} from "../../queries/payrollQuries";
import { toast } from "react-toastify";

const SalaryComponentListData = ({ requestdata, onEdit }) => {
  const [isActive, setIsActive] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null); 

  const updateStatusMutation = useUpdateSalaryComponentActiveStatus();
  const deleteMutation = useDeleteSalaryComponents(); 

  useEffect(() => {
    if (typeof requestdata?.is_active === "boolean") {
      setIsActive(requestdata.is_active);
    }
  }, [requestdata?.is_active]);

  const handleToggle = (newStatus) => {
    if (typeof newStatus !== "boolean") return;

    setIsActive(newStatus);

    updateStatusMutation.mutate(
      {
        salary_component_id: requestdata?.salary_component_id,
        is_active: newStatus,
      },
      {
        onSuccess: (data) => {
          if (data?.status) toast.success(data?.message || "Status updated successfully");
          else toast.error(data?.message || "Failed to update status");
        },
        onError: (error) => {
          toast.error(error?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };


  const handleDeleteClick = () => {
    setConfirmDeleteId(requestdata?.salary_component_id);
  };
  const handleConfirmDelete = () => {
    deleteMutation.mutate(
      { component_id: requestdata?.salary_component_id },
      {
        onSuccess: (res) => {
          toast.success(res?.message || "Salary component deleted");
          setConfirmDeleteId(null);
        },
        onError: (err) => {
          toast.error(err?.response?.data?.message || "Failed to delete");
          setConfirmDeleteId(null);
        },
      }
    );
  };
  const handleCancelDelete = () => {
    setConfirmDeleteId(null);
  };

  const autoCalculatedValue = 5;
  const pecentageCalculatedValue = 2;

  return (
    <tr className="bg-white border-b hover:bg-gray-50 dark:hover:bg-gray-200">
      <td className="px-10 py-4">{requestdata?.earning_type}</td>

      <td className="px-10 py-4">
        {requestdata?.calculation_type === Number(autoCalculatedValue)
          ? "Auto Calculated"
          : `${requestdata?.to_be_calculated_value}${
              requestdata?.calculation_type === Number(pecentageCalculatedValue)
                ? " %"
                : ""
            }`}
      </td>

      <td className="px-10 py-4">{requestdata?.calculated_from}</td>

      <td className="px-10 py-4">
        {Array.isArray(requestdata?.statutory_component_ids) &&
        requestdata.statutory_component_ids.length > 0
          ? "Yes"
          : "No"}
      </td>

      <td className="px-10 py-4">
        <ToggleSwitch
          checked={isActive}
          getToggleState={handleToggle}
          disabled={updateStatusMutation.isLoading}
        />
      </td>

      <td className="py-4 flex items-center justify-center gap-5">
      
        {confirmDeleteId === requestdata?.salary_component_id ? (
          <div className="flex items-center gap-2">
            <span className="text-xs text-gray-600">Confirm?</span>

            <button
              className="text-red-600 text-xs font-semibold"
              onClick={handleConfirmDelete}
            >
              Yes
            </button>

            <button
              className="text-gray-500 text-xs"
              onClick={handleCancelDelete}
            >
              No
            </button>
          </div>
        ) : (
          <img
            src="/images/delete-menu-icon.svg"
            alt="Delete"
            className="cursor-pointer"
            onClick={handleDeleteClick}
          />
        )}

        <img
          src="/images/edit-black-icon.svg"
          alt="Edit"
          className="cursor-pointer"
          onClick={() => onEdit(requestdata)}
        />
      </td>
    </tr>
  );
};

export default SalaryComponentListData;
